import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import { isAuthenticated } from './Services/auth';
import AdminLayout from './globals/Components/Layout/AdminLayout';
import Principal from './Components/Principal/Principal';
import Productos from './Components/Commerce/Productos/Productos';
import Login from './Components/MsIdentity/Login';
import Register from './Components/MsIdentity/Register';
import ForgotPassword from './Components/MsIdentity/ForgotPassword';
import ProductoDetalle from './Components/Commerce/Productos/ProductoDetalle';
import Ofertas from './Components/Commerce/Ofertas/Ofertas';
import CarritoPage from './Components/Commerce/Carrito/CarritoPage';
import Reservas from './Components/Commerce/Reservas/Reservas';
import MisReservas from './Components/Commerce/MisReservas/MisReservas';
const ConfigRouter: React.FC = () => {
  return (
    <Router>
      <Switch>
        {/* Ruta Principal: Usa PublicRoute porque no mencionaste que sea privada */}
        <PublicRoute 
          exact 
          path="/" 
          component={Principal} 
        />
        <PublicRoute exact path="/dashboard" component={Principal} /> 

        {/* Ruta de Productos: También como pública según pediste antes */}
        <PublicRoute 
          exact 
          path="/products" 
          component={Productos} 
        />
        {/* Ruta para el detalle del producto */}
        <PublicRoute
          exact
          path="/products/:id"
          component={ProductoDetalle}
        />
        {/* Ruta de Ofertas */}
        <PublicRoute
          exact
          path="/ofertas"
          component={Ofertas}
        />
        {/* Ruta del carrito */}
        <PublicRoute
          exact
          path="/carrito"
          component={CarritoPage}
        />
        {/* Ruta admin de Reservas — el propio componente redirige si no es admin */}
        <PublicRoute
          exact
          path="/reservas"
          component={Reservas}
        />
        {/* Ruta de reservas del usuario — el propio componente redirige si no hay sesión */}
        <PublicRoute
          exact
          path="/mis-reservas"
          component={MisReservas}
        />
       {/* *Ruta para login */}
        <Route 
          exact 
          path="/login" 
          component={Login} 
        />{/*Ruta para register*/ }
        <Route
          exact
          path="/register"
          component={Register}
        />
        {/* Ruta para recuperar contraseña */}
        <Route
          exact
          path="/forgot-password"
          component={ForgotPassword}
        />

        {/* Las rutas privadas usarían el PrivateRoute de abajo si las activas */}
        {/* <PrivateRoute exact path="/admin/dashboard" component={AdminDashboard} /> */}

        <Redirect from="*" to="/" />
      </Switch>
    </Router>
  );
};

/**
 * Función para rutas que CUALQUIERA puede ver
 * Envuelve el componente automáticamente en el AdminLayout
 */
const PublicRoute = (props: any) => {
  const { component: Component, ...rest } = props;
  return (
    <Route 
      {...rest} 
      render={(routeProps) => (
        <AdminLayout>
          <Component {...routeProps} />
        </AdminLayout>
      )} 
    />
  );
};

/**
 * Función para rutas que requieren LOGIN
 * Verifica isAuthenticated() y si no, redirige al login
 */
function PrivateRoute(props: any) {
  const { component: Component, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(routeProps) =>
        isAuthenticated() ? (
          <AdminLayout>
            <Component {...routeProps} />
          </AdminLayout>
        ) : (
          <Redirect to={{ pathname: '/admin/login' }} />
        )
      }
    />
  );
}

export default ConfigRouter;
